import { Button } from '@prishapolicy/shared/ui';
import { PrishaPolicyAdvantage } from './advantage';
import { ImageOverlayCard } from './image-overlay-card';
import { BlogBlueCard } from './blog-blue-card';
import { Callout } from './callout';
import H1 from './h1';
import H2 from './h2';
import Img from './img';
import { Note } from './note';
import Youtube from './youtube';
export const mdxElements = {
  Youtube,
  h2: H2,
  Img,
  h1: H1,
  Button: Button,
  Callout: Callout,
  a: (props: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>) => (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    (<a {...props} className="text-blue-700" />)
  ),
  Note,
  PrishaPolicyAdvantage,
  ImageOverlayCard,
  BlogBlueCard,
  // Lottie,
};
